import {
  LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

export default function GraficoEquilibrio({ data }) {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <XAxis dataKey="unidades" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="ingresos" stroke="#2e7d32" />
        <Line type="monotone" dataKey="costosTotales" stroke="#c62828" />
      </LineChart>
    </ResponsiveContainer>
  );
}
